import React, { useEffect } from 'react';
import { Button, Header, Popup } from 'semantic-ui-react';
import { useTitleDispatch } from '../../TitleContextProvider';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { Mode, CLONE_PREFIX } from '../../../constants';
import { defaultDateFormat } from '../../../Dates';
import i18n from 'i18next';
import { ChemicalProduct, Inventory } from "../../../routes";
import { history } from '../../../store';
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

const ChemicalProductDetailsTitleContainer = ({
  chemicalProduct,
  isChemProdRouter,
  isHistory,
  mode,
  t
}) => {
  const dispatch = useTitleDispatch();
  const inventory = useSelector(state => state.inventories.inventory);
  const location = useLocation();

  useEffect(() => {
    if (isChemProdRouter) {
      let historyDate = chemicalProduct.histCreateDte
        ? moment(chemicalProduct.histCreateDte).format(defaultDateFormat)
        : null;

      let pageTitle = t('page.chemical.product.create.new');
      if (chemicalProduct.tradeName) {
        if (!isHistory) {
          pageTitle = t(`chemical.product.details.page.title.${mode}`, {
            title:
              mode === Mode.CLONE
                ? chemicalProduct.tradeName.replace(CLONE_PREFIX, '')
                : chemicalProduct.tradeName
          });
        } else {
          pageTitle = t('chemical.product.details.page.history.title', {
            title: chemicalProduct.tradeName,
            histDate: historyDate,
            histUser: chemicalProduct.histCreateUser.name
          });
        }
      }

      dispatch({ pageTitle });
    }
  }, [mode, i18n.language]);

  const renderChemicalProductDetailsButton = () => {
    const routerBaseName = location.pathname.split(/(?=\/)/g)[0];
    if ([Mode.EDIT, Mode.VIEW].includes(mode) && routerBaseName === Inventory.baseName) {

      const {chemicalProduct: product} = inventory || {};
      const chemProdId = product?.chemicalProductId
          ? product?.chemicalProductId
          : product?.id;

      return product && <Popup
          className='inlineSiblingDivs'
          key="chemical.product.button.tooltip"
          trigger={
            <Button
                type="button"
                icon="icon-bond-list"
                className="marginLeftButton mini"
                onClick={() => history.push(`${ChemicalProduct.baseName}/view/${chemProdId}`)}
            />
          }
          on={['hover']}
          size="mini"
          content={t('details.chemical.product.button.tooltip')}
          position="bottom left"
      />
    }
    return null
  }
  return (
      <div>
          <Header as="h2" className='inlineSiblingDivs'>
            {chemicalProduct.tradeName || <br/>}
          </Header>
        {renderChemicalProductDetailsButton()}
      </div>
  );
};

export default withTranslation()(ChemicalProductDetailsTitleContainer);